module.exports = __webpack_public_path__ + "img/102.6.db7cd4d7.png";